// extracted by mini-css-extract-plugin
export var avatarContainer = "_4a-0";
export var gray = "_4a-f";
export var green = "_4a-c";
export var icon = "_4a-9";
export var image = "_4a-1";
export var lg = "_4a-6";
export var md = "_4a-5";
export var presenceDot = "_4a-b";
export var red = "_4a-d";
export var sm = "_4a-4";
export var status = "_4a-a";
export var xl = "_4a-7";
export var xs = "_4a-3";
export var xxl = "_4a-8";
export var xxs = "_4a-2";
export var yellow = "_4a-e";